<template>
  <div>
    <Toast />

    <Loader :isVisible.sync="loaderTrue" :text="'Carregando'" />
    <!-- <div class="dropdown">				
            <i class="pi pi-question-circle " style="fontSize:2rem;">
            </i>
            <span style="margin-left:0.4rem;font-size:1rem;vertical-align:super;font-family:Arial;font-weight:bold">Ajuda</span>					
            <div class="dropdown-content">
                <a class="link-text" style="font-family:Arial;cursor:pointer" @click="downloadManual()">Manual de Uso</a>
                <a class="link-text" style="font-family:Arial;cursor:pointer" @click="redirecionamento('faq')">FAQ</a>
                <a class="link-text" style="font-family:Arial;cursor:pointer" @click="redirecionamento('faleconosco')">Fale Conosco</a>
            </div>								
        </div> -->

    <Login
      v-if="
        !isUserLogado &&
          !(
            this.$route.name &&
            this.$route.name.split('-').length > 0 &&
            this.$route.name.split('-')[1] == 'publico'
          )
      "
    />

    <div v-else :class="containerClass" @click="onWrapperClick">
      <AppTopBar @menu-toggle="onMenuToggle" />

      <div class="layout-sidebar  layout-sidebar-light" @click="onSidebarClick" style="display:flex; flex-direction:column">
        <div class="layout-logo">
          <router-link :to="{ name: 'recadastramento' }">
            <img alt="seplag" src="./assets/LOGO SEPLAG - BRANCO VAZADO.svg" />
          </router-link>
        </div>
        <AppProfile :ontrocarSenha="trocarSenha" />
        <AppMenu :model.sync="menu" @menuitem-click="onMenuItemClick" />

        <div  class="versao" >
          {{ versaoFRONT }} - {{ versaoAPI }}
        </div>
      </div>

      <div class="layout-main">
        <router-view v-if="isExisteUser" />

        <cadastro-rapido
          tituloTela="Trocar a Senha"
          v-model="exibirTelaTrocarSenha"
          :modoEdicao="modoEdicao"
          :onAlterar="atualizarSenha"
          :visivelFechar="visivelFecharTela"
          v-if="exibirTelaTrocarSenha"
          :textoButton="'Alterar'"
        >
          <Rotulo nome="Senha Atual" cols="12">
            <InputText
              type="password"
              v-model="registroLogin.senhaAtual"
              v-required
            />
          </Rotulo>
          <Rotulo nome="Nova Senha" cols="12">
            <InputText
              type="password"
              v-model="registroLogin.senhaNova"
              v-required
            />
          </Rotulo>
          <Rotulo nome="Confirma Nova Senha" cols="12">
            <InputText
              type="password"
              v-model="registroLogin.confirmarSenha"
              v-required
            />
          </Rotulo>
        </cadastro-rapido>
      </div>
      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppProfile from './AppProfile.vue';
import AppMenu from './AppMenu.vue';
import AppFooter from './AppFooter.vue';
import Login from './paginas/login/Login.vue';
import { mapGetters } from 'vuex';
import CadastroRapido from '@/template/CadRapidoSeplag.vue';
import Loader from '@/paginas/Loader.vue';
import Rotulo from '@/template/RotuloSeplag.vue';
import { baseApiUrl,    } from '@/config/global';

const getDefaultState = () => {
  return {
    // id: '',
    login: '',
    senhaAtual: '',
    senhaNova: '',
    confirmarSenha: '',
  };
};

export default {
  data() {
    return {
      layoutMode: 'static',
      layoutColorMode: 'dark',
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      exibirTelaTrocarSenha: false,
      visivelFecharTela: true,
      fecharMenuProfile: false,
      loaderTrue: false,
      modoEdicao: 'alterar',
      registroLogin: getDefaultState(),
      vinculos: null,
      registroVinculo: null,
      user: null,
      menu: null,
      versaoAPI: '',
      versaoFRONT: '',
    };
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    },
    isLoader(newLoader) {
      this.loaderTrue = newLoader;
    },
    isversaoAPI(newVersaoApi) {
      this.versaoAPI = newVersaoApi;
    },
    isExisteUser(novaresposta, antigaResposta) {
      if (novaresposta != antigaResposta && novaresposta) {
        this.menu = [
          {
            label: 'Tela Inicial',
            icon: 'pi pi-fw pi-home',
            to: '/' + process.env.VUE_APP_BASE_URL,
          },
        ];

        if (this.isUserTemPerssao('FORMPREFEITURA_MENU')) {
          this.menu.push({
            label: 'Prefeitura de Cuiabá',
            icon: 'pi pi-fw pi-user-edit',
            to:
              '/' +
              process.env.VUE_APP_BASE_URL +
              '/prefeituraCba',
          });
        }

        if(this.isUserTemPerssao('cadastroPerfilUsuario')){
            this.menu.push({label: 'Cadastro Perfil', icon: 'pi pi-fw pi-sitemap', to: '/'+process.env.VUE_APP_BASE_URL+'/seguranca/cadastro/perfil'})
        }

        if (this.isUserTemPerssao('GERENCIARELATORIO_MENU')) {
          this.menu.push({
            label: 'Relatórios',
            icon: 'pi pi-fw pi-file-pdf',
            to: '/' + process.env.VUE_APP_BASE_URL + '/gerencia/relatorios',
          });
        }    

        if (this.isUserTemPerssao('CHEFIAGERENCIA')) {
          this.menu.push({
            label: 'Validação Usuário',
            icon: 'pi pi-fw pi-users',
            to: '/' + process.env.VUE_APP_BASE_URL + '/gerencia/pendente',
          });
        }
        // if (this.isUserTemPerssao('administrativoCiclo')) {
        //   this.menu.push({
        //     label: 'Gerencia de Ciclo',
        //     icon: 'pi pi-fw pi-cog',
        //     to: '/' + process.env.VUE_APP_BASE_URL + '/administrativo/ciclos',
        //   });
        // }
        
        if (this.isUserTemPerssao('GESTAOPESSOA_MENU')) {
          let menuAdmin = [];

          if (this.isUserTemPerssao('CADUSUARIO_MENU')) {
            menuAdmin.push({
              label: 'Usuários',
              icon: 'pi pi-fw pi-circle-on',
              to:
                  '/' +
                  process.env.VUE_APP_BASE_URL +
                  '/seguranca/cadastro/usuario',
            });
          }

          if (this.isUserTemPerssao('GERENCIACICLO_MENU')) {
            menuAdmin.push({
              label: 'Gerenciar Ciclo',
              icon: 'pi pi-fw pi-cog',
              to: '/' + process.env.VUE_APP_BASE_URL + '/ciclo',
            });
          }

          if (this.isUserTemPerssao('REGULARIZACAOSERVIDORES_MENU')) {
            menuAdmin.push({
              label: 'Cadastro de Exceção',
              icon: 'pi pi-fw pi-circle-on',
              to: '/' + process.env.VUE_APP_BASE_URL + '/gerencia/regularizacaoServidor',
            });
          }

          if (this.isUserTemPerssao('GESTAOPESSOA_CADASTRO_CHEFIA_VIEW')) {
            menuAdmin.push({
              label: 'Cadastro de Chefia',
              icon: 'pi pi-fw pi-circle-on',
              to:
                  '/' +
                  process.env.VUE_APP_BASE_URL +
                  '/parametrizacoes/cadastroChefia',
            });
          }

          if (this.isUserTemPerssao('GESTAOPESSOA_CADASTRO_UECMP_VIEW')) {
            menuAdmin.push({
              label: 'Cadastro UECMP',
              icon: 'pi pi-fw pi-circle-on',
              to:
                  '/' +
                  process.env.VUE_APP_BASE_URL +
                  '/parametrizacoes/cadastroUECMP',
            });
          }

          if (this.isUserTemPerssao('RESET_CADASTRO')) {
            menuAdmin.push({
              label: 'Resetar Cadastro',
              icon: 'pi pi-fw pi-circle-on',
              to:
                  '/' + process.env.VUE_APP_BASE_URL + '/parametrizacoes/consultaCadastro',
            });
          }

          if (this.isUserTemPerssao('MANTER_ASSUNTO')) {
            menuAdmin.push({
              label: 'Cadastrar Assunto',
              icon: 'pi pi-fw pi-circle-on',
              to: '/' + process.env.VUE_APP_BASE_URL + '/parametrizacoes/buscarAssunto',
            });
          }

          if (this.isUserTemPerssao('MANTER_EMAIL')) {
            menuAdmin.push({
              label: 'Cadastrar E-mail',
              icon: 'pi pi-fw pi-circle-on',
              to: '/' + process.env.VUE_APP_BASE_URL + '/parametrizacoes/consultarEmail',
            });
          }

          if (this.isUserTemPerssao('GESTAOPESSOA_IMPORTE_BASE_EXTERNA_VIEW')) {
            menuAdmin.push({
              label: 'Importar Base Externa',
              icon: 'pi pi-fw pi-circle-on',
              to:
                  '/' +
                  process.env.VUE_APP_BASE_URL +
                  '/parametrizacoes/basesExternas',
            });
          }

          if (this.isUserTemPerssao('GESTAOPESSOA_ORGAOS_VINCULADOS_VIEW')) {
            menuAdmin.push({
              label: 'Órgãos Vinculados',
              icon: 'pi pi-fw pi-circle-on',
              to:
                  '/' +
                  process.env.VUE_APP_BASE_URL +
                  '/parametrizacoes/orgaosVinculados',
            });
          }

          if (this.isUserTemPerssao('GESTAOPESSOA_AUDITORIA_VIEW')) {
            menuAdmin.push({
              label: 'Auditoria',
              icon: 'pi pi-fw pi-circle-on',
              to:
                  '/' + process.env.VUE_APP_BASE_URL + '/parametrizacoes/auditoria',
            });
          }

          if (this.isUserTemPerssao('RECADVIEW_MENU')) {
            menuAdmin.push({
              label: 'Analisar Atualização',
              icon: 'pi pi-fw pi-circle-on',
              to:'/' +process.env.VUE_APP_BASE_URL +'/recadView',
            });
          }

          if (this.isUserTemPerssao('GESTAOPESSOA_PERMISSOES_VIEW')) {
            menuAdmin.push({
              label: 'Permissões de Relatórios',
              icon: 'pi pi-fw pi-circle-on',
              to:
                '/' +
                process.env.VUE_APP_BASE_URL +
                '/parametrizacoes/permissoes',
            });
          }





          this.menu.push({
            label: 'Parametrizações',
            icon: 'pi pi-fw pi-users',
            items: menuAdmin,
          });
        }
        // NOVA INSERÇÃO
        // if (this.isUserTemPerssao('RELATORIO_MENU')) {
        //   this.menu.push({
        //     label: 'Relatórios',
        //     icon: 'pi pi-fw pi-file-pdf',
        //     to: '/' + process.env.VUE_APP_BASE_URL + '/gerencia/relatorios',
        //   });
        // }

        if (
          this.$store.getters.getUser &&
          this.$store.getters.getUser.contaAcesso.trocarSenha == 'S'
        ) {
          this.exibirTelaTrocarSenha = true;
          this.visivelFecharTela = false;
          this.registroLogin = getDefaultState();
        }
      } //else{
      // this.menu = [{label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/recadastramento'}]
      // }
    },
  },
  methods: {
    async validateToken() {
      var dataToken = null;
      this.versaoFRONT = process.env.VUE_APP_VERSAO;
      if (localStorage.getItem(process.env.VUE_APP_USER_KEY)) {
        dataToken = JSON.parse(
          atob(localStorage.getItem(process.env.VUE_APP_USER_KEY))
        );
      }
      if (dataToken) {
        if (!this.$store.getters.isUserLogado) {
          this.$store.commit('setUserLogado', true);
        }

        if (!this.$store.getters.getToken) {
          this.$store.commit('setToken', dataToken.token);
        }
        if (!this.$store.getters.getUser) {
          await this.$store.dispatch('buscarUsuario', this);
        }
      }
    },
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }

      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        if (this.layoutMode === 'overlay') {
          this.overlayMenuActive = !this.overlayMenuActive;
        } else if (this.layoutMode === 'static') {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += ' ' + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            '(^|\\b)' + className.split(' ').join('|') + '(\\b|$)',
            'gi'
          ),
          ' '
        );
    },
    isDesktop() {
      return window.innerWidth > 1024;
    },
    atualizarSenha() {
      // this.registroLogin.id = this.$store.getters.getUser.contaAcesso.id
      this.registroLogin.login = this.$store.getters.getUser.contaAcesso.login;
      this.$http
        .put(
          `${baseApiUrl}/seguranca/contasacesso/senha/${this.$store.getters.getUser.contaAcesso.id}`,
          JSON.stringify(this.registroLogin)
        )
        .then((res) => {
          this.$toast.add({
            severity: 'success',
            summary: res.data,
            life: 3000,
          });
          this.$store.dispatch('buscarUsuario', this);
          this.exibirTelaTrocarSenha = false;
        })
        .catch((error) => {
          for (let i = 0; i < error.response.data.length; i++) {
            this.$toast.add({
              severity: 'error',
              summary: error.response.data[i].msgUsuario,
              life: 3000,
            });
          }
        });
    },
    trocarSenha() {
      this.exibirTelaTrocarSenha = true;
      this.visivelFecharTela = true;
      this.registroLogin = getDefaultState();
    },
    asUser() {
      if (
        this.$store.getters.getUser &&
        this.$store.getters.getUser.trocarSenha == 'S'
      ) {
        this.exibirTelaTrocarSenha = true;
        this.visivelFecharTela = false;
        this.registroLogin = getDefaultState();
        this.registroLogin.id = this.$store.getters.getUser.id;
        this.registroLogin.login = this.$store.getters.getUser.login;
      }
    },
    interageLoder(loader) {
      this.loaderTrue = loader;
    },
    beforeUpdate() {
      if (this.mobileMenuActive)
        this.addClass(document.body, 'body-overflow-hidden');
      else this.removeClass(document.body, 'body-overflow-hidden');
    },
    isUserTemPerssao(nomerota) {
      
      // let possuiAcesso = false;
      // let perfilUsers = this.$store.getters.getUser.contaAcesso.authorities;
      // let perfilUsers2 = this.$store.getters.getUser.contaAcesso.direitosDinamicos; 

      let authorities = this.$store.getters.getUser.contaAcesso.authorities.map((role)=>role.nomeRole) || [];
      let direitosDinamicos = this.$store.getters.getUser.contaAcesso.direitosDinamicos.map((role)=>role.nomeRole) || [];

      let listAuthorities = [
        ...authorities,
        ...direitosDinamicos
      ]
      
      return listAuthorities.find((role)=> role == nomerota)
      
      // if (perfilUsers2  && perfilUsers2.length > 0){
      //   let perfis =  [...perfilUsers,...perfilUsers2]
        
      //   let verifica = perfis.filter(function(element) {
      //     return element.nomeRole == nomerota;
      //   });
      //   if (verifica && verifica.length > 0) {
      //     possuiAcesso = true;
      //   } 
        
      // }else if (perfilUsers && perfilUsers.length > 0) {
      //   let verifica = perfilUsers.filter(function(element) {
      //     return element.nomeRole == nomerota;
      //   });
      //   if (verifica && verifica.length > 0) {
      //     possuiAcesso = true;
      //   } 
      // }  else {
      //   for (let i = 0; i < perfilUsers.length; i++) {
      //     let permissao = perfis.filter(function(element) {
      //       return element.perfil == perfilUsers[i].nomeRole;
      //     });
      //     if (permissao.length > 0) {
      //       let verifica = permissao[0].permissoes.filter(function(element) {
      //         return element == nomerota;
      //       });
      //       if (verifica && verifica.length > 0) {
      //         possuiAcesso = true;
      //         break;
      //       }
      //     }
      //   }
      // }
      // return possuiAcesso;
    },
    redirecionamento(nome) {
      if (nome != this.$route.name) {
        this.$router.push({ name: nome });
      }
    },
    downloadManual() {},
  },
  created() {
    this.validateToken();
  },
  computed: {
    ...mapGetters(['isUserLogado']),
    containerClass() {
      if (!this.isUserLogado) {
        return [
          'layout-wrapper',
          {
            'layout-overlay': this.layoutMode === 'overlay',
            'layout-static': this.layoutMode === 'static',
            'layout-static-sidebar-inactive': true,
            'layout-overlay-sidebar-active':
              this.overlayMenuActive && this.layoutMode === 'overlay',
            'layout-mobile-sidebar-active': this.mobileMenuActive,
          },
        ];
      } else {
        return [
          'layout-wrapper',
          {
            'layout-overlay': this.layoutMode === 'overlay',
            'layout-static': this.layoutMode === 'static',
            'layout-static-sidebar-inactive':
              this.staticMenuInactive && this.layoutMode === 'static',
            'layout-overlay-sidebar-active':
              this.overlayMenuActive && this.layoutMode === 'overlay',
            'layout-mobile-sidebar-active': this.mobileMenuActive,
          },
        ];
      }
    },
    sidebarClass() {
      return [
        'layout-sidebar',
        {
          'layout-sidebar-dark': this.layoutColorMode === 'dark',
          'layout-sidebar-light': this.layoutColorMode === 'light',
        },
      ];
    },
    logo() {
      //return (this.layoutColorMode === 'dark') ? "assets/layout/images/logo-white.svg" : "assets/layout/images/logo.svg";
      return 'assets/seplag.png';
    },
    isLoader() {
      return this.$store.getters.isloader;
    },
    isExisteUser() {
      return this.$store.getters.getUser ? true : false;
    },
    isversaoAPI() {
      return this.$store.getters.getVersaoApi;
    },
  },
  components: {
    AppTopBar: AppTopBar,
    AppProfile: AppProfile,
    AppMenu: AppMenu,
    AppFooter: AppFooter,
    Login: Login,
    Loader: Loader,
    Rotulo,
    CadastroRapido,
  },
};
</script>

<style lang="scss" scoped>
@import './App.scss';

.versao{
  width: 100%;
    text-align: center;
    top: 20px;
    color: rgb(255, 255, 255);
    flex: 1 1 0%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}
.dropdown {
  position: fixed;
  z-index: 1000;
  top: 93vh;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  align-content: space-around;
  padding: 12px 25px;
  /* width: 100%; */
}

.dropdown-content {
  display: none;
  position: absolute;
  /* right: 0; */
  top: -120px;
  background-color: #f9f9f9;
  min-width: 160px;
  /* box-shadow: 0px 8px 16px 0px rgb(0 0 0 / 20%); */
  z-index: 1;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  text-align: left;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown-content a:hover {
  background-color: #f1f1f1;
}
</style>
